import React, { useMemo } from 'react';

import { Box, Link, Typography } from '@mui/material';

import { formatDateWeekDayShortMonth } from '~/services/TimeService';

import { RecentlyViewedProduct, getRecentlyViewedProducts } from '~/utils/recentlyViewedProducts';

const isNewDay = (idx: number, date: string, recentProducts: Array<RecentlyViewedProduct>) => {
  if (idx === 0) {
    return true;
  }
  const previousDate = new Date(recentProducts[idx - 1].date);
  const currentDate = new Date(date);
  return previousDate.toDateString() !== currentDate.toDateString();
};

export default function RecentlyViewedProducts() {
  const recentProducts = useMemo(() => getRecentlyViewedProducts(), []);

  return (
    <Box>
      <Typography variant="h4">Recently viewed products</Typography>
      <Box component="ul" sx={{ listStyle: 'none', m: 0, mt: 1.5, p: 0 }}>
        {recentProducts.map((product, idx) => (
          <Box
            component="li"
            key={product.id}
            sx={{
              borderRadius: 1,
              mb: 0.25,
              mx: -0.75,
              px: 0.75,
              py: 0.25,
              '&:hover': {
                bgcolor: 'action.hover',
              },
            }}
          >
            {isNewDay(idx, product.date, recentProducts) && (
              <Typography
                component="pre"
                variant="body2"
                sx={{ color: 'text.secondary', fontFamily: 'monospace', m: 0, mt: idx === 0 ? 0 : 2, mb: 0.5 }}
              >
                {formatDateWeekDayShortMonth(product.date)}
              </Typography>
            )}
            <Box
              sx={{
                alignItems: 'baseline',
                columnGap: 1.25,
                display: 'grid',
                gridTemplateColumns: '88px minmax(0, 1fr)',
              }}
            >
              <Typography
                component="span"
                variant="caption"
                color="text.secondary"
                sx={{
                  fontSize: '0.75rem',
                  lineHeight: 1.5,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
                title={product.productLabel}
              >
                {product.productLabel}
              </Typography>
              <Link
                href={product.href}
                underline="hover"
                sx={{
                  fontSize: '0.875rem',
                  lineHeight: 1.5,
                  overflowWrap: 'anywhere',
                  textDecorationThickness: '1px',
                  textUnderlineOffset: '2px',
                }}
              >
                {product.label}
              </Link>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
